// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  cacheBusterHash: '__cacheBusterHash__',
  production: true,
  alleAuthConfig: {
    clientID: '__authClientID__',
    domain: '__authDomain__',
    responseType: 'token id_token',
    audience: '__authAudience__',
    redirectUri: '__redirectURL__',
    logoutUrl: '__logoutUrl__',
    scope: 'openid companyservice:access',
    inAppRedirects: {
      loggedIn: '/profile',
      error: '/error',
    },
    silentAuthPage: '__silentAuthPage__',
    connection: '__connection__',
  },
  baseAPIUrl: '__baseAPIUrl__',
  apiUrl: '__apiUrl__',
  appInsightsInstrumentationKey: '__appInsightsKey__',
  personaUrl: '__personaUrl__',
  countryUrl: '__countryUrl__',
  phoneCodesUrl: '__phoneCodesUrl__',
  supportContact: '__supportContact__',
  flags: {
    integrations: '__flagIntegrations__',
  },
  usePermit:'__usePermit__'
};
